// MockBankTreasuryAdapter — simulates bank treasury/operations systems
// Pattern follows src/services/kycVendors/screeningAdapter.js

let _dealNoCounter = 6;

export class MockBankTreasuryAdapter {
  constructor() {
    this.name = 'mock-bank-treasury';
  }

  isAvailable() {
    return true;
  }

  /**
   * Book a deal in the bank's systems. Returns { bankDealNo }.
   */
  async bookDeal({ quoteId, rfqId, counterpartyId, currencyPair, side, amount, rate, counterAmount }) {
    await delay(300);
    const dealNo = `EAB-FX-2026-${pad(new Date().getMonth() + 1)}${pad(new Date().getDate())}-${String(_dealNoCounter++).padStart(3, '0')}`;
    return {
      bankDealNo: dealNo,
      quoteId,
      rfqId,
      bookedAt: new Date().toISOString(),
    };
  }

  /**
   * Get SSI for a counterparty.
   */
  async getSsi(counterpartyId) {
    await delay(100);
    // Return generic SSI — in production this comes from bank core
    return {
      counterpartyId,
      nostroBank: 'Equity Africa Bank',
      nostroAccount: 'KES-NOSTRO-001',
      nostroSwift: 'EABORKENX',
    };
  }

  /**
   * Export regulatory data as CSV blob.
   */
  async exportRegulatory(filters = {}) {
    await delay(400);
    const headers = ['Date', 'DealNo', 'CurrencyPair', 'Side', 'Amount', 'Rate', 'Counterparty', 'Purpose', 'Status'];
    const rows = [
      ['2026-09-12', 'EAB-FX-2026-0912-001', 'EUR/KES', 'Sell', '1200000', '142.35', 'Horizon Impact Partners', 'Investment', 'Awaiting Funds'],
      ['2026-09-12', 'EAB-FX-2026-0912-002', 'USD/KES', 'Sell', '2000000', '129.45', 'Savanna SFO Ltd', 'Investment', 'Confirmed'],
      ['2026-09-12', 'EAB-FX-2026-0912-003', 'USD/KES', 'Buy', '800000', '129.30', 'Horizon Impact Partners', 'Repatriation', 'Booked'],
      ['2026-09-11', 'EAB-FX-2026-0911-001', 'USD/KES', 'Sell', '450000', '129.55', 'Mwamba Family Trust', 'Investment', 'CSD Confirmed'],
      ['2026-09-11', 'EAB-FX-2026-0911-003', 'GBP/UGX', 'Sell', '750000', '4622.50', 'James Okonkwo', 'Capital Call', 'Awaiting Funds'],
    ];

    const csv = [headers.join(','), ...rows.map(r => r.join(','))].join('\n');
    return {
      format: 'csv',
      data: csv,
      generatedAt: new Date().toISOString(),
      filters,
    };
  }
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function pad(n) {
  return String(n).padStart(2, '0');
}
